import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import Stack from '@mui/material/Stack';
import { useTheme, SxProps } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import * as React from 'react';

interface InfoContainerProps {
  description: string;
  style?: SxProps;
}

const InfoContainer = ({ description, style }: InfoContainerProps) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap="10px"
      sx={{
        padding: '8px 16px',
        border: `1px solid ${theme?.palette?.toastWarning?.[200]}`,
        background: theme?.palette?.toastWarning?.[50],
        borderRadius: '4px',
        marginBottom: '16px',
        ...style
      }}
    >
      <WarningRoundedIcon
        sx={{
          color: theme?.palette?.toastWarning?.[800]
        }}
      />
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 400,
          color: theme?.palette?.common?.black,
          fontFamily: theme?.MojitoClaim?.font?.tertiary
        }}
      >
        {description}
      </Typography>
    </Stack>
  );
};

export default InfoContainer;
